import { RadioItem, RadioSelectItem, SelectItem, TypedFactory } from '@/store/prescription/definition/categories/prescriptionCategoriesDefinition';
import { LROptions, TopCovers } from '@/store/prescription/prescription-types';

const topCoverMaterial: SelectItem<TopCovers['topCoverMaterial']> = {
	description:
		'Top Covers are used to create a soft interface between the foot and the 3D printed orthotic shell. A variety of materials offer differing effects. Poly-U and Neolon provide shock absorption and have good “memory”. EVA and Ucolite have excellent shock absorbing properties. Plastazote reduces high pressure areas and reduces shock. Microsuede or Vinyl are a great choice for a high-end look for a non-athletic orthotics.',
	display: 'Top Cover Material',
	imgPath: '/assets/images/prescriptions/Top Cover Material-2.svg',
	selectValues: {
		'eva-black-1-16': 'EVA Black 1.5mm',
		'eva-black-1-8': 'EVA Black 3mm',
		'black-microsuede': 'Microsuede Black',
		'neolon-black-1-16': 'Neolon Black 1.5mm',
		'neolon-black-1-8': 'Neolon Black 3mm',
		'plastazote-1-8': 'Plastazote Black 3mm',
		'poly-u-1-16-vinyl': 'Vinyl 1.5mm',
		'ucolite-black-perforated-1-16': 'Ucolite Black Perforated 2mm',
		'black-vinyl': 'Vinyl Black'
	}
};

const midLayerMaterial: SelectItem<TopCovers['midLayerMaterial']> = {
	description:
		'For additional cushioning, add another layer underneath the top cover. Use 1/8” or 1/16” poron with Neolon for maximum cushioning in the custom orthoses.',
	display: 'Mid Layer Material',
	imgPath: '/assets/images/prescriptions/Top Cover Midlayer.svg',
	selectValues: {
		none: 'None',
		'eva-black-1-16': 'EVA Black 1.5mm',
		'eva-black-1-8': 'EVA Black 3mm',
		'poly-u-1-16': 'Poly-U 1.5mm',
		'poly-u-1-8': 'Poly-U 3mm'
	}
};

const bottomCover: SelectItem<TopCovers['bottomCover']> = {
	description:
		'Our bottom cover is a very thin Black Micro-suede that covers 1” from the distal edge of the orthotic to the toes. It is not a full heel to toe cover bottom cover. Add a bottom cover to improve stiffness in the forefoot and to provide a more finished look.',
	display: 'Bottom Cover',
	imgPath: '/assets/images/prescriptions/Top Cover Bottomlayer.svg',
	selectValues: {
		none: 'None',
		'eva-black-1-24': 'EVA Black 1mm',
		suede: 'Suede',
		vinyl: 'Vinyl'
	}
};

const topCoverLength: RadioItem<TopCovers['topCoverLength']> = {
	description:
		'The Top Cover length will determine which part of the foot will have padding underneath it. The length is measured from the back of the heel cup to a forward point. The metatarsal length is just behind the ball of the foot, the sulcus length is just behind the toes and the toe length is just past the end of the toes. In all instances Top Covers add a slight amount of bulk.',
	display: 'Top Cover Length',
	imgPath: '/assets/images/prescriptions/Top Cover Length.svg',
	radioValues: {
		met: 'Met Length',
		sulcus: 'Sulcus Length',
		full: 'Full Length'
	}
};

const widenTopcoverAtForefootTwoSizes: RadioItem<LROptions> = {
	description: `This is best used for shoes
where width fitting might be an
issue in the forefoot. This does
not affect shell width.`,
	display: 'Widen top cover at forefoot 2 sizes',
	radioValues: {
		none: 'N/A',
		left: 'L',
		right: 'R',
		both: 'B/L'
	},
	imgPath: '/assets/images/prescriptions/widen_top_cover_2_sizes.svg'
};

const navicularWing: RadioItem<LROptions> = {
	description: `This is a top cover extension that arcs
above the medial shell over the navicular
area to provide cushion between the
midfoot and the shoe. This does not affect
the shell. Also called a P-Wing`,
	display: 'Navicular Wing',
	radioValues: {
		none: 'N/A',
		left: 'L',
		right: 'R',
		both: 'B/L'
	},
	imgPath: '/assets/images/prescriptions/Navicular_wing.svg'
};

const coverSpecialRX: string[] = [];

const typeFactory = new TypedFactory<TopCovers>();
export default typeFactory.typeItems({
	topCoverMaterial,
	midLayerMaterial,
	bottomCover,
	topCoverLength,
	coverSpecialRX,
	widenTopcoverAtForefootTwoSizes,
	navicularWing
});
